import React from 'react';
import { Card } from 'reactstrap';
import InventoryStatisticsChart from './InventoryStatisticsChart';

const InventoryStatistics = ({ data }) => {
 return (
  <>
   <Card className=" h-100">
    <div className="nk-ecwg nk-ecwg8 h-100">
     <div className="card-inner">
      <div className="card-title-group mb-3">
       <div className="card-title">
        <h6 className="title">Inventory Statistics</h6>
       </div>
       <div className="card-tools">
       </div>
      </div>
      <div style={{ height: "350px" }}>
       <InventoryStatisticsChart data={data} />
      </div>
     </div>
    </div>
   </Card>
  </>
 );
};

export default InventoryStatistics;